export var CustomPDFReportModuleSize;
(function (CustomPDFReportModuleSize) {
    CustomPDFReportModuleSize["PAGE_SIZE_QUARTER"] = "quarter";
    CustomPDFReportModuleSize["PAGE_SIZE_THIRD"] = "third";
    CustomPDFReportModuleSize["PAGE_SIZE_HALF"] = "half";
    CustomPDFReportModuleSize["PAGE_SIZE_ONE"] = "one";
})(CustomPDFReportModuleSize || (CustomPDFReportModuleSize = {}));
export var CustomPDFReportTearsheetModuleSize;
(function (CustomPDFReportTearsheetModuleSize) {
    CustomPDFReportTearsheetModuleSize["QUARTER_PAGE_BY_QUARTER_PAGE"] = "quarter_page_by_quarter_page";
    CustomPDFReportTearsheetModuleSize["HALF_PAGE_BY_EIGHTH_PAGE"] = "half_page_by_eighth_page";
    CustomPDFReportTearsheetModuleSize["FULL_PAGE_BY_EIGHTH_PAGE"] = "full_page_by_eighth_page";
    CustomPDFReportTearsheetModuleSize["HALF_PAGE_BY_QUARTER_PAGE"] = "half_page_by_quarter_page";
    CustomPDFReportTearsheetModuleSize["FULL_PAGE_BY_QUARTER_PAGE"] = "full_page_by_quarter_page";
    CustomPDFReportTearsheetModuleSize["HALF_PAGE_BY_HALF_PAGE"] = "half_page_by_half_page";
    CustomPDFReportTearsheetModuleSize["FULL_PAGE_BY_HALF_PAGE"] = "full_page_by_half_page";
    CustomPDFReportTearsheetModuleSize["FULL_PAGE_BY_FULL_PAGE"] = "full_page_by_full_page";
})(CustomPDFReportTearsheetModuleSize || (CustomPDFReportTearsheetModuleSize = {}));
export var CustomPDFReportModuleCategory;
(function (CustomPDFReportModuleCategory) {
    CustomPDFReportModuleCategory["BASIC_INFO_AND_PERFORMANCE"] = "Basic Info & Performance";
    CustomPDFReportModuleCategory["ATTRIBUTION_ANALYSIS"] = "Attribution Analysis";
    CustomPDFReportModuleCategory["RISK"] = "Risk";
    CustomPDFReportModuleCategory["ALLOCATIONS"] = "Allocations";
    CustomPDFReportModuleCategory["HOLDINGS"] = "Holdings";
    CustomPDFReportModuleCategory["PROPOSALS_AND_SCENARIOS"] = "Proposals & Scenarios";
    CustomPDFReportModuleCategory["CHARTS_AND_TABLES"] = "Charts & Tables";
    CustomPDFReportModuleCategory["DISCLOSURES_AND_DEFINITIONS"] = "Disclosures & Definitions";
    CustomPDFReportModuleCategory["OTHER"] = "Other";
})(CustomPDFReportModuleCategory || (CustomPDFReportModuleCategory = {}));
export var CustomPDFReportModuleFieldType;
(function (CustomPDFReportModuleFieldType) {
    CustomPDFReportModuleFieldType["BOOLEAN"] = "BooleanField";
    CustomPDFReportModuleFieldType["CHAR"] = "CharField";
    CustomPDFReportModuleFieldType["CUSTOM_TEXT"] = "CustomTextField";
    CustomPDFReportModuleFieldType["IMAGE"] = "ImageField";
    CustomPDFReportModuleFieldType["INFO_LIST"] = "InfoListField";
    CustomPDFReportModuleFieldType["SELECT"] = "SelectField";
    CustomPDFReportModuleFieldType["METRIC"] = "MetricField";
    CustomPDFReportModuleFieldType["METRICS_LIST"] = "MetricsListField";
    CustomPDFReportModuleFieldType["METRIC_GROUPS"] = "MetricGroupsField";
    CustomPDFReportModuleFieldType["SAVED_ASSET_OPTIONS"] = "SavedAssetOptions";
    CustomPDFReportModuleFieldType["SAVED_ITEM_FIELD"] = "SavedItemField";
    CustomPDFReportModuleFieldType["SECURITY"] = "SecurityField";
    CustomPDFReportModuleFieldType["SELECT_TALKING_POINTS"] = "SelectTalkingPointsField";
    CustomPDFReportModuleFieldType["STRESS_TEST"] = "StressTestsField";
    CustomPDFReportModuleFieldType["TALKING_POINTS"] = "TalkingPointsField";
    CustomPDFReportModuleFieldType["RADIO_GROUP"] = "RadioGroupField";
    CustomPDFReportModuleFieldType["SELECT_TRANSITION_ANALYSIS"] = "SelectTransitionAnalysisField";
    CustomPDFReportModuleFieldType["RADIO_GROUP_WITH_CUSTOM_VALUE"] = "RadioGroupWithCustomValueField";
    CustomPDFReportModuleFieldType["RISK_PROFILES"] = "RiskProfilesListField";
    CustomPDFReportModuleFieldType["RISK_METRIC_FIELD"] = "RiskMetricField";
})(CustomPDFReportModuleFieldType || (CustomPDFReportModuleFieldType = {}));
